import React from 'react';

const About = () => {
    return (
        <div>
            <h1>This is about pages</h1>
        </div>
    );
};

export default About;